import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { useCommunicationMode } from '@hooks'

import { FloatingActionButton } from '@components/ui/Buttons'
import { Portal } from '@components/ui/Portal'
import { MailOutlineIcon } from '@components/ui/svgIcons'
import { Tooltip } from '@components/ui/Tooltips'

import { COMMUNICATION_MODE_HUBSPOT } from '@constants'

import { SUPPORT_LAUNCHER } from './constants'
import { getLauncherVisibilityStyles, useIsSupportSlideOverOpen } from './launcherVisibility'
import { useHubSpotLauncher } from './useHubSpotLauncher'
import { useOpenSupportSlideOver } from './useOpenSupportSlideOver'

import { messages as formMessages } from '@components/forms/MessageToAccountantForm/messages'

const ICON_SIZE = 30

const FabWrapper = styled.div<{ $hasChatLauncher: boolean; $isHidden: boolean }>`
  position: fixed;
  bottom: ${SUPPORT_LAUNCHER.bottom}px;
  right: ${SUPPORT_LAUNCHER.bottom}px;
  z-index: ${({ theme }) => theme.zIndex.floatingSupport};

  ${({ $hasChatLauncher, $isHidden }) => getLauncherVisibilityStyles({ $hasChatLauncher, $isHidden })}
`

export function MessageToAccountantFab() {
  const { formatMessage } = useIntl()
  const communicationMode = useCommunicationMode()
  const openSlideOver = useOpenSupportSlideOver()
  const isHidden = useIsSupportSlideOverOpen()
  const { isChatOpen, isPresent: hasChatLauncher } = useHubSpotLauncher()

  if (communicationMode !== COMMUNICATION_MODE_HUBSPOT) {
    return null
  }

  const title = formatMessage(formMessages.title)

  return (
    <Portal anchorEl={document.body}>
      <FabWrapper
        $hasChatLauncher={hasChatLauncher}
        $isHidden={isHidden}
        data-chat-launcher={hasChatLauncher ? 'present' : 'absent'}
        data-hidden={isHidden}
      >
        <Tooltip title={isChatOpen ? formatMessage(formMessages.chatOpenHint) : title}>
          <FloatingActionButton
            aria-disabled={isChatOpen ? 'true' : undefined}
            aria-label={title}
            data-testid="message-to-accountant-fab"
            onClick={isChatOpen ? undefined : openSlideOver}
          >
            <MailOutlineIcon size={ICON_SIZE} />
          </FloatingActionButton>
        </Tooltip>
      </FabWrapper>
    </Portal>
  )
}
